// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories-1FD1Z","select":"select-1YN7I"};